import './index.scss'
import fullpage from 'fullpage.js'
import 'fullpage.js/dist/fullpage.min.css'
import Swiper from 'swiper/swiper-bundle.min'
import '../../assets/scripts/jquery.mousewheel'

$(document).ready(function(){
  if($(window).width() > 1024){
    initFullpage()
  }
})

//全屏滚动
var afullpage;
function initFullpage() {
  afullpage = new fullpage('#fullpage', {
    scrollingSpeed: 600,
    css3: true,
    resize:true,
    autoScrolling: true,
    scrollBar: false,
    anchors: ['page1', 'page2'],
    afterLoad: function (origin, destination, direction, trigger) {
      let i = destination.index;
      if(i == 1){
        afullpage.setAllowScrolling(false);
        $('.article-solution-fixed-btn').addClass('go-back')
      }else{
        $('.article-solution-fixed-btn').removeClass('go-back')
      }
    },
    onLeave: function (origin, destination, direction,trigger) {
    }
  });
}

$('.article-solution-fixed-btn').on('click',function(){
  if($(this).hasClass('go-back')){
    window.close()
  }
})

//底部footer效果
function footerF(event, delta){
  let footerH = $('.fixed-footer').outerHeight()
  if(delta > 0){//返回，上滚
    if(!$('.fixed-footer').hasClass('show')){
      afullpage.setAllowScrolling(true);
    }else{
      $('.fixed-footer').removeClass('show')
      $('.footer-tran').css('transform','none')
      $('.trans-menu').css('transform','translateY(0px)')
    }
  }else if(delta < 0){//下滚，显示footer
    if(!$('.fixed-footer').hasClass('show')){
      $('.fixed-footer').addClass('show')
      $('.footer-tran').css('transform','translateY('+ -footerH +'px)')
      $('.trans-menu').css('transform',' translateY('+ -footerH +'px)')
    }
  }
  event.preventDefault();
}

if($(window).width() > 1024){
  $('#fullpage .section2').bind('mousewheel',function(event, delta) {
    footerF(event, delta)
  });
  $('.fixed-footer').mousewheel(function(event, delta) {
    if(delta > 0){//返回，上滚
      $('.fixed-footer').removeClass('show')
      $('.footer-tran').css('transform','none')
      $('.trans-menu').css('transform','translateY(0px)')
    }
    event.preventDefault();
  });
}


var swiper1 = new Swiper(".section2 .right .mySwiper", {
  speed: 600,
  watchOverflow: true,
  autoplay: {
    delay: 3000,
    stopOnLastSlide: false,
    disableOnInteraction: false,
  },
  navigation: {
    nextEl: '.section2 .right .swiper-button-next',
    prevEl: '.section2 .right .swiper-button-prev'
  },
  pagination: {
    el: ".section2 .right .swiper-pagination",
    clickable: true
  },
});